<!-- <header class="navbar">
  <div class="brand">
    <button class="menu-btn" (click)="toggle.emit()">☰</button>
    <span>ANPR Dashboard</span>
  </div>
  <div class="nav-icons">
    <span class="icon">🔔</span>
    <span class="icon">👤</span>
  </div>
</header> -->


<header class="navbar">
    
    <div class="brand">
      <button class="menu-btn" type="button" aria-label="Toggle navigation menu" (click)="toggle.emit()">☰</button>
      <img src="logo/kyra_quote-removebg-preview.png" alt="Company Logo">
    </div>
    <!-- <h4>{{ currentPageTitle }}</h4> -->
    <div class="navbar-icons">
      <div class="profile-menu">
        <button type="button" aria-label="Toggle notifications" (click)="toggleNotifications()">
          <!-- <i class="bi bi-bell-fill large-icon"></i> -->
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24"><path fill="currentColor" d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2m6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5z"/></svg>
        </button>
        <div class="notification" *ngIf="notificationOpen">
            <div *ngFor="let notification of (isSeeAllNotification ? notificationData : notificationData | slice:0:3); let i = index">
              <div  class="notification-item">
                <img src="logo/kyra-logo-no-bg.png" alt="Profile" class="notification-profile-pic"> <!-- Profile picture -->
                <div class="notification-content">
                  <strong>{{notification.title}}</strong>
                  <p>{{notification.message}}</p>
                  <small>{{ getRelativeTime(notification.created_at) }}</small> <!-- Use the new method here -->
                </div>
              </div>
              <hr class="notification-divider">
            </div>
            
          <div class="see-all" *ngIf="!(notificationData.length == 0)">
            <button (click)="seeAllNotifications()" *ngIf="!isSeeAllNotification">See All 
              <fa-icon [icon]="['fas', 'angle-right']" ></fa-icon>
            </button> <!-- See all button -->

            <button (click)="seeAllNotifications()" *ngIf="isSeeAllNotification">See Less
              <fa-icon [icon]="['fas', 'angle-up']" ></fa-icon>
            </button> <!-- See all button -->
          </div>
          <div class="see-all" *ngIf="notificationData.length === 0">
            <p>There is no notifications</p>
          </div>
        </div>
        

      </div>
      <div class="profile-menu">
        <button type="button" aria-label="Open profile menu" (click)="toggleDropdown()">
           <!-- <i class="bi bi-person-fill-gear large-icon-account"></i> -->
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M11.5 4a3.5 3.5 0 1 0 0 7a3.5 3.5 0 0 0 0-7M6 7.5a5.5 5.5 0 1 1 11 0a5.5 5.5 0 0 1-11 0M8 16a4 4 0 0 0-4 4h8.05v2H2v-2a6 6 0 0 1 6-6h4v2zm11.5-3.25v1.376c.715.184 1.352.56 1.854 1.072l1.193-.689l1 1.732l-1.192.688a4 4 0 0 1 0 2.142l1.192.688l-1 1.732l-1.193-.689a4 4 0 0 1-1.854 1.072v1.376h-2v-1.376a4 4 0 0 1-1.854-1.072l-1.193.689l-1-1.732l1.192-.688a4 4 0 0 1 0-2.142l-1.192-.688l1-1.732l1.193.688a4 4 0 0 1 1.854-1.071V12.75zm-2.751 4.283a2 2 0 0 0-.25.967c0 .35.091.68.25.967l.036.063a2 2 0 0 0 3.43 0l.036-.063c.159-.287.249-.616.249-.967c0-.35-.09-.68-.249-.967l-.036-.063a2 2 0 0 0-3.43 0z"/></svg>
        </button>
        <div class="dropdown dropdown-align" *ngIf="dropdownOpen">
          <a (click)="profilePage()">
            <fa-icon [icon]="['fas', 'user']" class="fa-solid"></fa-icon>
            <span class="dropdown-label">Profile</span>
          </a>
            <a (click)="changePassword()">
            <fa-icon [icon]="['fas', 'gear']" class="fa-solid"></fa-icon>
            <span class="dropdown-label">Settings</span>
          </a>
          <hr>
          <a (click)="logout()">
            <fa-icon [icon]="['fas', 'power-off']" class="fa-solid"></fa-icon>
            <span class="dropdown-label">Logout</span>
          </a>
        </div>
      </div>
      
    </div>
</header>
